/**
export const msalConfig = {
  auth: {
    clientId: config.auth.clientId, // Replace with your Azure AD app client ID
    authority: config.auth.authority, // Replace with your Azure AD tenant ID
    redirectUri: config.auth.redirectUri, // Replace with your app's redirect URI (as configured in Azure AD)
  },
};

*/


/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */


export const getMsalConfig = () => ({

    auth: {
        clientId: '0eabd70b-0291-4e18-91fe-4389c2eb7bba',
        authority: 'https://login.microsoftonline.com/a00c0469-8b25-4b75-ba6c-e8aa467c9bbe',
        redirectUri: "/app",
        postLogoutRedirectUri: "/",
        navigateToLoginRequestUrl: false,
    },
    cache: {
        //        cacheLocation: "sessionStorage",
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Verbose,
            loggerCallback: (level, message) => {
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        break;
                    case LogLevel.Info:
                        console.info(message);
                        break;
                    case LogLevel.Verbose:
                        console.debug(message);
                        break;
                    case LogLevel.Warning:
                        console.warn(message);
                        break;
                    default:
                        console.log(message);
                        break;
                }
            },

            piiLoggingEnabled: false  // Do not log Personally Identifiable Information
        }
    }

});

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 * 
 * scopes: ["User.Read", "Group.Read.All", "User.ReadBasic.All"],
 */
export const loginRequest = {
    scopes: ["User.Read", "Group.Read.All", "User.ReadBasic.All"],
    clientId: '0eabd70b-0291-4e18-91fe-4389c2eb7bba',
    prompt: 'select_account'
};
